export default __webpack_public_path__ + "static/media/empty-state.93e1d165.svg";